var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStorefrontLinesheet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.12,6.71 L17.29,3.88 C16.7279306,3.31723005 15.9653814,3.00070021 15.17,3 L8.83,3 C8.0346186,3.00070021 7.27206943,3.31723005 6.71,3.88 L3.88,6.71 C3.31723005,7.27206943 3.00070021,8.0346186 3,8.83 L3,18 C3,19.6568542 4.34314575,21 6,21 L18,21 C19.6568542,21 21,19.6568542 21,18 L21,8.83 C20.9992998,8.0346186 20.6827699,7.27206943 20.12,6.71 Z M8.12,5.29 C8.31163379,5.10726627 8.56523302,5.00368349 8.83,5 L15.17,5 C15.434767,5.00368349 15.6883662,5.10726627 15.88,5.29 L17.59,7 L6.41,7 L8.12,5.29 Z M18,19 L6,19 C5.44771525,19 5,18.5522847 5,18 L5,9 L19,9 L19,18 C19,18.5522847 18.5522847,19 18,19 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,11 C14.4477153,11 14,11.4477153 14,12 C14,13.1045695 13.1045695,14 12,14 C10.8954305,14 10,13.1045695 10,12 C10,11.4477153 9.55228475,11 9,11 C8.44771525,11 8,11.4477153 8,12 C8,14.209139 9.790861,16 12,16 C14.209139,16 16,14.209139 16,12 C16,11.4477153 15.5522847,11 15,11 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStorefrontLinesheet);
export default __webpack_public_path__ + "static/media/icon_storefront_linesheet.f16eaeff.svg";
export { ForwardRef as ReactComponent };